import { render, staticRenderFns } from "./offer-card.vue?vue&type=template&id=61dce83f&scoped=true"
import script from "./offer-card.ts?vue&type=script&lang=ts&external"
export * from "./offer-card.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dce83f",
  null
  
)

export default component.exports